import React from 'react';

import { Text } from '@betterment/samba-react';
import { css } from '@betterment/samba-styled-system/css';
import { SambaAutoLink } from '@betterment/shared-components';

import { useReferralSenderOffer } from './ReferAFriendProvider';

import { trackClick } from '../../features/track';
import { urlBuilder } from '../../Shared/urlBuilder';

const nowrap = css.raw({
  whiteSpace: 'nowrap',
});

type Props = {
  trackingModule: string;
  displaySpecificOfferDetails?: boolean;
};

const OfferDetails: React.FC<Props> = ({ trackingModule }) => {
  const { senderOfferName } = useReferralSenderOffer();
  if (senderOfferName == null) return null;

  return (
    <div>
      <Text
        as="p"
        color="text.weak"
        css={{
          marginTop: 'space.0',
          fontSize: 'fontSize.50',
        }}
      >
        By referring a friend, you acknowledge that you have read and agreed to the{' '}
        <SambaAutoLink
          onClick={() => trackClick({ name: 'OfferTerms', module: trackingModule })}
          to={urlBuilder.getOfferTerms.absolute({ offerName: senderOfferName })}
          title="Referral Program terms and conditions for sending user"
          css={nowrap}
        >
          Terms and Conditions
        </SambaAutoLink>
        , and certify that (i) you have had no{' '}
        <SambaAutoLink
          onClick={() => trackClick({ name: 'DisqualifyingEvents', module: trackingModule })}
          to={urlBuilder.getDisqualifyingEventsPage()}
          title="Disqualifying events"
          css={nowrap}
        >
          Disqualification Events
        </SambaAutoLink>{' '}
        in the last 10 years and (ii) have informed Betterment of any conflicts of interest that exist between you and
        Betterment. At the time of referring a friend, you must include the following disclosure: “FYI - I’m a client of
        Betterment and, if you fund a new account, I receive compensation for this referral. You can see what others say
        about Betterment in reviews in the{' '}
        <SambaAutoLink
          onClick={() => trackClick({ name: 'AppStoreSelected', module: trackingModule })}
          to={urlBuilder.getIosAppStoreUrl()}
          title="App store events"
          css={nowrap}
        >
          App Store
        </SambaAutoLink>{' '}
        and{' '}
        <SambaAutoLink
          onClick={() => trackClick({ name: 'AppStoreSelected', module: trackingModule })}
          to={urlBuilder.getAndroidGooglePlayStoreUrl()}
          title="Google play events"
          css={nowrap}
        >
          Google Play Store
        </SambaAutoLink>
        ."
      </Text>
    </div>
  );
};

export default OfferDetails;
